type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function Badge({ children, className = "" }: Props) {
  return (
    <div
      className={`absolute top-6 left-6 bg-white/80 dark:bg-black/50 backdrop-blur-md text-midnight_text dark:text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest shadow-sm border border-border dark:border-white/10 ${className}`}
    >
      {children}
    </div>
  );
}
